import { render } from "./Menu.vue?vue&type=template&id=86b70f98&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=86b70f98&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86b70f98"]])

export default __exports__